<template>
  <div class="pdf-zoom">
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="flat-primary"
      class="btn-icon rounded-circle"
      @click.stop="download"
      v-if="displayDownloadBtn"
    >
      <feather-icon icon="DownloadIcon" />
    </b-button>
    <b-button
      v-if="isPdf"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="flat-primary"
      class="btn-icon rounded-circle"
      @click.stop="print"
    >
      <feather-icon icon="PrinterIcon" />
    </b-button>
    <b-button
      v-if="isPdf"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="flat-primary"
      class="btn-icon rounded-circle"
      @click.stop="zoomOut"
    >
      <feather-icon icon="ZoomOutIcon" />
    </b-button>
    <b-button
      v-if="isPdf"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="flat-primary"
      class="btn-icon rounded-circle"
      @click.stop="zoomIn"
    >
      <feather-icon icon="ZoomInIcon" />
    </b-button>
    <!-- <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="flat-primary"
      class="btn-icon rounded-circle"
      @click.stop="maximize(true)"
      v-if="!isMaximize"
    >
      <feather-icon icon="MaximizeIcon" />
    </b-button>
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="flat-primary"
      class="btn-icon rounded-circle"
      @click.stop="maximize(false)"
      v-else
    >
      <feather-icon icon="MinimizeIcon" />
    </b-button> -->
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import { BButton } from "bootstrap-vue";
export default {
  components: {
    BButton
  },
  directives: {
    Ripple,
  },
  props: {
    newsViewData: {
      type: Object,
    },
    scale: {
      type: Number,
      default: 1.0,
    },
    increment: {
      type: Number,
      default: 0.25,
    },
    isMaximize: {
      type: Boolean,
      default: false,
    },
    displayDownloadBtn: {
      type: Boolean,
      default: false,
    },
    isDesktop: {
      type: Boolean,
    },
  },
  computed: {
    isPdf() {
      if (!this.newsViewData.document) return false;
      return this.newsViewData.document.extension == 'pdf';
    }
  },
  methods: {
    zoomIn() {
      this.$emit("change", this.scale + this.increment);
    },
    zoomOut() {
      if (this.scale <= this.increment) return;
      this.$emit("change", this.scale - this.increment);
    },
    maximize(value) {
      this.$emit("maximize", value);
    },
    print() {
      this.$emit("printPdf", true);
    },
    download() {
      this.$emit("download", true);
    },
  },
};
</script>

<style>
.pdf-zoom {
  cursor: pointer;
  text-align: right;
  display: contents;
}
.pdf-zoom.header-item {
  /* position: absolute; */
  right: 10px;
  top: 70px;
}
.pdf-document {
  margin-top: 30px;
}
.pdf-zoom.header-item {
  display: flex;
}
button.vs-component.vs-button.vs-button-primary.vs-button-filled.includeIcon.includeIconOnly.vs-radius {
  background: #fff !important;
  color: #000 !important;
  font-size: 2rem !important;
  margin-right: 10px;
  box-shadow: none !important;
}
.theme-dark
  button.vs-component.vs-button.vs-button-primary.vs-button-filled.includeIcon.includeIconOnly.vs-radius {
  background: #353e45 !important;
  color: #fff !important;
}
.theme-dark
  button.vs-component.vs-button.vs-button-primary.vs-button-filled.includeIcon.includeIconOnly.vs-radius:hover {
  background: #2d343b !important;
}

button.vs-component.vs-button.vs-button-primary.vs-button-filled.includeIcon.includeIconOnly.vs-radius:hover {
  background: #eaefdf !important;
}
.icon-zoom-out,
.icon-zoom-in,
.icon-minimize,
.icon-maxmize {
  font-size: 1.4rem;
}
</style>
